__turbopack_context__.v({
  "className": "lato_28223fe-module__VOuadq__className",
  "variable": "lato_28223fe-module__VOuadq__variable",
});
